module.exports = __webpack_public_path__ + "static/media/Tommen Baratheon 3.502b9512.jpg";